import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MealModel } from '../../../models/home/meal-model';
import {CommonModule} from "@angular/common";
import {TooltipModule} from "primeng/tooltip";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {DialogModule} from "primeng/dialog";
import {DividerModule} from "primeng/divider";
import {DropdownModule} from "primeng/dropdown";
import {SharedModule} from "primeng/api";
import {FormsModule} from "@angular/forms";
import {OrangeButtonComponent} from "../orange-button/orange-button.component";
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-meal-card',
  templateUrl: './new-meal-card.component.html',
  styleUrls: ['./new-meal-card.component.scss'],
  standalone: true,
  imports: [CommonModule, TooltipModule, DialogModule, DividerModule, DropdownModule, SharedModule, FormsModule, OrangeButtonComponent],
  animations: [
    trigger(
        'enterAnimation', [
          transition(':enter', [
            style({transform: 'translateY(-100%)', opacity: 0}),
            animate('500ms', style({transform: 'translateY(0)', opacity: 1}))
          ]),
        ]
    ),
    trigger('fade', [
      transition(':enter', [ // using status here for transition
        style({ opacity: 0 }),
        animate(200, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate(200, style({ opacity: 0 }))
      ])
    ]),
    trigger('widthGrow', [
      state('closed', style({
        height: 50,
      })),
      state('open', style({
        height: 40
      })),
      transition('* => *', animate(150))
    ]),
    trigger('fade_obj', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(800, style({opacity: 1}))
      ])
    ])
  ],
})
export class NewMealCardComponent {

  @Input() isCurrentMenu: boolean = false; // used to hide the Add/Remove meal buttons. Used in Current Menu
  @Input() showMealDetails: boolean = true; // disable the opening of the Meal Details popup

  @Input() meal: MealModel; 
  @Output() increaseQuantity = new EventEmitter<MealModel>();
  @Output() decreaseQuantity = new EventEmitter<MealModel>();
  @Output() removeMeal = new EventEmitter<MealModel>();
  @Output() addMeal = new EventEmitter<MealModel>();

  mealPopUpVisibility: boolean = false;

  constructor(private router: Router) {}
  

  mouseEnter(meal: any) {
    meal.show_nutrients = false;
    meal.state = 'open';
  }

  mouseLeave(meal: any) {
    meal.show_nutrients = true;
    meal.state = 'closed';
  }

  increaseCount() {
    this.increaseQuantity.emit(this.meal);
  }

  decreaseCount() {
    this.decreaseQuantity.emit(this.meal);
  }

  getMealDescription(meal: MealModel) {
    return meal.description && meal.description.length > 100 ? (meal.description.substring(0, 90) + "...") : meal.description;
  }

  remove() {
    this.removeMeal.emit(this.meal);
  }

  add() {
    this.addMeal.emit(this.meal);
  }

  goToOrderFlow() {
    this.mealPopUpVisibility = false;
    this.router.navigate(["order-flow"]);
  }
  
  showMealInPopup() {
    if(this.showMealDetails) {
      this.mealPopUpVisibility = true;
    }
  }

  hideMealInPopup() {
    this.mealPopUpVisibility = false;
  }


}